import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = { class: "o-box u-bg-color-5 -box-padding-sm" }
const _hoisted_3 = { class: "-p-lg" }
const _hoisted_4 = { class: "o-box__inner" }
const _hoisted_5 = { class: "o-box__item" }
const _hoisted_6 = { class: "o-form" }
const _hoisted_7 = { class: "o-form-row -col-1/2" }
const _hoisted_8 = { class: "o-form__item" }
const _hoisted_9 = { class: "o-select__wrap" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "admission-type"
}, null, -1 /* HOISTED */)
const _hoisted_11 = { value: "" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  "aria-hidden": "true",
  tabindex: "-1",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_14 = { class: "o-form__item" }
const _hoisted_15 = { class: "o-select__wrap" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "admission-type"
}, null, -1 /* HOISTED */)
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  "aria-hidden": "true",
  tabindex: "-1",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_20 = { class: "c-admission-preparation__wrap js-admission-preparation__wrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "o-spacer -spacer-xs" }, null, -1 /* HOISTED */)
const _hoisted_22 = {
  key: 0,
  class: "c-admission-preparation-default o-text"
}
const _hoisted_23 = {
  key: 1,
  class: ""
}
const _hoisted_24 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($options.t("Veuillez sélectionner un type de personnel et une catégorie")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectedNom) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_11, _toDisplayString($options.t("Qui êtes-vous?")), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.personnaNoms, (nom) => {
                      return (_openBlock(), _createElementBlock("option", { value: nom }, _toDisplayString(nom), 9 /* TEXT, PROPS */, _hoisted_12))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.selectedNom]
                  ]),
                  _hoisted_13
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedType) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_17, _toDisplayString($options.t("Catégories")), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedSujetTypes, (t) => {
                      return (_openBlock(), _createElementBlock("option", { value: t }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_18))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.selectedType]
                  ]),
                  _hoisted_19
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            ($options.selectedTexte=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: "c-admission-result o-text",
                    innerHTML: $options.selectedTexte
                  }, null, 8 /* PROPS */, _hoisted_24)
                ]))
          ])
        ])
      ])
    ])
  ]))
}